<app-admir-user-menu></app-admir-user-menu>
<div  style="height:100%; background-color: red;">
    <mat-tab-group >
        <mat-tab label="Map" >
    
            <div>
                 <app-google-maps #googleMaps
                 (UserSiteConfirmationCompleteEvent)="userSiteConfirmationCompleteEvent($event)"
    
                 ></app-google-maps>
            </div>
            <app-sites-mat-table-maint #sitesMatTableMaint  [itemsPerPage]=5 [companyId]="companyId" 
            (SitesReadyCompleteEvent)="sitesReadyCompleteEvent($event)"
            (UserSiteConfirmationCompleteEvent)="userSiteConfirmationCompleteEvent($event)"
            ></app-sites-mat-table-maint>
    
        </mat-tab>
        <mat-tab label="List">
            <app-sites-mat-table-maint #sitesMatTableMaint2 [itemsPerPage]=15  [companyId]="companyId" 
            (UserSiteConfirmationCompleteEvent)="userSiteConfirmationCompleteEvent($event)"></app-sites-mat-table-maint>
    
        </mat-tab>
    </mat-tab-group>
    </div>